import React from "react";
import Modal from "react-modal";
import "../ProjectV2/Render/RenderStyle.css";

Modal.setAppElement("#root");

const FreePlanConfirmModal = ({ isOpen, onConfirm, onCancel, planName }) => {
  const modalStyles = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#1a1a1a",
      borderRadius: "12px",
      padding: "30px",
      width: "400px",
      height: "max-content",
      maxWidth: "90%",
      outline: "1px solid #ffffff33",
      zIndex: 1000,
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 999,
    },
  };

  return (
    <Modal isOpen={isOpen} style={modalStyles} onRequestClose={onCancel}>
      <div className="flex flex-col gap-4">
        <h2 className="text-[22px] manrope-600 text-white mb-2">
          Confirm Free Plan
        </h2>
        <p className="text-[16px] manrope-400 text-[#ffffffcc] mb-6">
          You will lose access to the free trial of 7 days if you proceed with the free plan.
        </p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-6 py-2 rounded-lg bg-[#333333] text-white text-[14px] manrope-500 hover:bg-[#444444] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2 rounded-lg PlanUpgradeBG text-white text-[14px] manrope-500 hover:bg-blue-700 transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FreePlanConfirmModal;
